import * as audio from './kernel/audio.js';
import * as main from './main.js';

export {
    init,
    status,
    showStart,
}

function init() {
    document.querySelector('.js-start').addEventListener('click', () => {
        if (DEVMODE) console.log('Starting...');
        document.querySelector('.js-start').classList.add('hidden');
        document.querySelector('.center').classList.add('hidden');
        document.querySelector('.screen').classList.remove('hidden');
        audio.resume().then(() => {
            main.start();
        });
    });
}

function status(status) {
    const statusEl = document.querySelector('#status');
    if (status === null) statusEl.classList.add('hidden');
    else statusEl.classList.remove('hidden');
    statusEl.innerText = status;
}

function showStart() {
    document.querySelector('.js-start').classList.remove('hidden');
    status(null);
}
